import { useCallback } from 'react';
import { Text } from 'foundations-components/components/Text';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Flex } from 'foundations-components/components/Flex';
import useDebounce from '../../hooks/useDebounce';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { SortTableAscIcon } from 'foundations-assets/icons/components/SortTableAscIcon';
import { useOneTimePassword } from './useOneTimePassword';
import { useQueryData } from '../../hooks/useQueryData';
import { View } from 'foundations-components/components/View';
import OneTimePasswordError from './OneTimePasswordError';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileOneTimePasswordComponent = props => {
  const {
    history
  } = props;
  const {
    allQueryParams
  } = useQueryData();
  const {
    otp,
    otpId,
    userId,
    next,
    template
  } = allQueryParams;
  const {
    isLoading,
    responseLanguageKey,
    onLoad,
    resendHandler,
    showActionButton,
    isError,
    templateLanguageKey,
    isLoginLoading,
    setIsLoginLoading
  } = useOneTimePassword({
    otp,
    otpId,
    next,
    template,
    userId
  });
  const debouncedOnLoad = useDebounce(onLoad, 1000);
  const handleClick = useCallback(() => {
    setIsLoginLoading(true);
    debouncedOnLoad();
  }, [debouncedOnLoad, setIsLoginLoading]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "start",
    justifyContent: "center",
    blockSize: "90vh",
    padding: "400",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "OTP_PAGE_LOAD"
    }), isLoading ? /*#__PURE__*/_jsx("div", {
      style: {
        height: '100%'
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        blockSize: "100%",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(View, {
            alignSelf: "end",
            children: /*#__PURE__*/_jsx(IconHolder, {
              icon: SortTableAscIcon,
              size: "600",
              display: "block",
              textAlign: "right",
              padding: "0"
            })
          }), /*#__PURE__*/_jsx(Text, {
            textAlign: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "login.otp.mobile.returnToApp"
            })
          })]
        }), /*#__PURE__*/_jsx(Flex, {
          flexGrow: 1,
          alignItems: "center",
          justifyContent: "center",
          children: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(Text, {
              textAlign: "center",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "login.otp.mobile.or"
              })
            }), /*#__PURE__*/_jsx(LoadingButton, {
              "data-test-id": "continue-in-browser",
              onClick: handleClick,
              use: "link",
              loading: isLoginLoading,
              disabled: isLoginLoading,
              marginBlockStart: "400",
              alignSelf: "center",
              size: "extra-small",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "login.otp.mobile.continueInBrowser"
              })
            })]
          })
        })]
      })
    }) : /*#__PURE__*/_jsx(OneTimePasswordError, {
      isError: isError,
      responseLanguageKey: responseLanguageKey,
      templateLanguageKey: templateLanguageKey,
      showActionButton: showActionButton,
      template: template,
      resendHandler: resendHandler,
      history: history
    })]
  });
};
export default MobileOneTimePasswordComponent;